<template>
  <div class="content">
    <div class="document-nav">
      <h2>Documents</h2>
    </div>
    <!-- <div class="employee-notice">
      <p>Download all the documents your company wants you to sign here:</p>
      <router-link
        name
        id
        class="btn btn-primary download-button"
        to="/documentUplaod"
        role="button"
      >Download Document</router-link>
    </div>-->
    <!-- documents for uploading -->
    <div class="form-row">
      <table class="table">
        <caption>Your Uploads</caption>
        <thead>
          <tr>
            <th>Name</th>
            <th>Date Uploaded</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr class="batch" v-for="doc in documentList" v-bind:key="doc.key">
            <td>
              <i class="fa fa-file-o inline" aria-hidden="true"></i>
              {{doc.name}}
            </td>
            <td>{{doc.date}}</td>
            <td>
              <i class="fa fa-download" title="download this document"></i>
              <span title="delete this document" class="remove--file">x</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="document-nav">
      <p>Upload New Document</p>
    </div>
    <div class="form-group">
      <label for>Name of Document:</label>
      <input
        type="text"
        v-model="docName"
        name
        id
        class="form-control"
        placeholder
        aria-describedby="helpId"
      />
    </div>
    <form id="file-upload-form" class="uploader">
      <label>Upload Document:</label>
      <input
        id="file-upload"
        type="file"
        name="fileUpload"
        @change="uploadFile"
        ref="doc"
        accept="files"
      />

      <label for="file-upload" id="file-upload">
        <div id="start" v-show="!uploadedFile">
          <i class="fa fa-upload" aria-hidden="true"></i>
          <div>upload jpeg, pdf, doc</div>
        </div>

        <div v-show="uploadedFile">{{uploadedFileName}}</div>
      </label>
    </form>

    <div class="fileupload__errors">
      <p v-if="documentError">You have not selected any document.</p>
      <p v-if="nameError">Please enter the name of the document.</p>
    </div>

    <div id="file-upload-btn" class="btn btn-primary" @click="sendFile" v-if="!loading">Upload</div>
    <div id="file-upload-btn" v-if="loading" class="btn btn-primary">
      <WhiteLoader />
    </div>
  </div>
</template>
<script>
import WhiteLoader from "../../partials/white-loader";
import * as types from "../../../store/constant";

export default {
  name: "EmployeeDocument",
  components: {
    WhiteLoader
  },
  data() {
    return {
      uploadedFile: false,
      file: "",
      fileName: "",
      uploadedFileName: "",
      docName: "",
      documentError: false,
      nameError: false,
      loading: false,
      documentList: [
        {
          name: "Guarantors Form",
          date: "01/01/2019"
        },
        {
          name: "NDA Form",
          date: "01/01/2019"
        },
        {
          name: "Employment Letter",
          date: "01/01/2019"
        }
      ]
    };
  },
  methods: {
    uploadFile() {
      this.documentError = false;
      this.nameError = false;
      this.fileName = this.$refs.doc;
      this.file = this.$refs.doc.files[0];

      if (this.file) {
        this.uploadedFile = true;
        this.uploadedFileName = this.fileName.value.split("\\").pop();
      }
    },
    sendFile() {
      this.documentError = false;
      this.nameError = false;

      if (this.docName.trim() === "") {
        this.nameError = true;
        return;
      }

      if (this.file) {
        this.loading = true;
        let formData = new FormData();
        formData.append("file", this.file);
        return;
      }

      this.documentError = true;
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import url(https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css);

div.content {
  padding-bottom: 100px;
  padding-top: 35px;
  padding-left: 60px;
  padding-right: 60px;
}
.document-nav {
  width: 980px;
  height: 35px;
  color: #302f2f;
  display: flex;
  border-bottom: 1px solid #ebe4e4;
  margin-top: 25px;
  h2 {
    font-family: Nunito;
    font-size: 2.008vw;
    font-weight: 900;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: left;
  }

  p {
    font-family: Nunito;
    font-size: 1.308vw;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: left;
    color: #000;
  }
}

.employee-notice {
  display: inline-flex;
  width: 610px;
  border-radius: 5px;
  box-shadow: 0 2px 4px 0 #fff9f0;
  border: solid 2px #ffe7bd;
  background-color: #fff9f0;
  padding: 20px;
  margin-top: 33px;
  margin-bottom: 33px;
  .download-button {
    width: 160px;
    height: 26px;
    border-radius: 2px;
    background-color: #5099de;
    font-family: Nunito;
    font-size: 0.75vw;
    margin-bottom: 0px;
  }

  p {
    font-weight: 500;
    font-family: Nunito;
    font-size: 1vw;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    margin-bottom: 0px;
  }
}
.form-row {
  width: 980px;
  margin-top: 15px;
  padding-bottom: 35px;

  table {
    width: 980px;
    border-collapse: separate;
    border-spacing: 0 1em;
    caption {
      caption-side: top;
      padding: 10px;
      font-weight: 600;
      font-family: Nunito;
      font-size: 1.3vw;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.67;
      letter-spacing: normal;
      color: #000000;
    }
    thead th {
      border: none;
      line-height: 2px;
      font-size: 1vw;
      padding-top: 25px;
    }

    tbody tr:first-child > td {
      border-top: 3px solid #5099de;
    }
    tr > td:first-child {
      color: #5099de;
    }

    th {
      width: 42%;
    }
    input {
      border: none;
    }
    td {
      width: 42%;
      padding-top: 17px;
    }
    tr.batch {
      height: 60px;
      border-radius: 2px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
      font-weight: 500;
      font-size: 1.078vw;
      color: #000;

      i {
        display: inline;
        padding-right: 10px;
        padding-left: 7px;
        cursor: pointer;
      }

      .remove--file {
        padding: 5px 0px 0px 2px;
        font-size: 1.6vw;
        font-weight: 600;
        color: #f3826c;
        cursor: pointer;
      }
    }
  }
}
.form-group {
  margin-top: 6em;
  display: flex;
  width: 550px;
  label {
    width: 300px;
  }
  input {
    padding-right: 15px;
    border-radius: 2px;
  }
}
.uploader {
  display: flex;
  width: 54%;
  margin-top: 4em;

  label {
    width: 308px;
    padding-top: 1.5em;
  }

  #file-upload {
    width: 100%;
    padding: 1em 1em;
    text-align: center;
    background: #fff;
    border-radius: 2px;
    border: 2px dotted #5099de;
    transition: all 0.2s ease;
    user-select: none;

    > img {
      width: 100%;
    }
  }

  #start {
    color: #5099de;
    font-size: 1vw;
    &.hidden {
      display: none;
    }
    i.fa {
      margin-bottom: 0.5em;
      transition: all 0.2s ease-in-out;
    }
  }

  input[type="file"] {
    display: none;
  }
}
#file-upload-btn {
  width: 160px;
  margin-top: 2em;
  font-family: inherit;
  font-weight: 500;
  font-size: 1vw;
  border-radius: 0.2rem;
  transition: all 0.2s ease-in-out;
  background-color: #5099de;
  cursor: pointer;
}

.fileupload__errors {
  font-size: 14px;
  font-style: italic;
  color: red;
}
</style>



